type Props = {
  source: any
  onSubmit: (sourceUpdated: any) => void
}

export const StepOne: React.FC<Props> = ({ source, onSubmit }) => {
  return <>TODO</>
  // const { data: providerAccount } = Api.providerAccount.findUnique.useQuery({
  //   where: { id: source.providerAccountId },
  // })

  // const accountConfiguration =
  //   providerAccount?.configuration as GoogleDocConfigurationConnect

  // // const { data: documents } = Api.googleDoc.findManyDocuments.useQuery(
  // //   {
  // //     nangoConnectionId: accountConfiguration?.nangoConnectionId,
  // //   },
  // //   { enabled: !!accountConfiguration },
  // // )
  // const documents = []

  // const FormInstance = FormClient.useForModel({
  //   modelName: 'IndexerSource',
  //   keysToMerge: ['configuration'],
  //   onSuccess: onSubmit,
  // })

  // const optionsDocuments = documents?.map(document => ({
  //   label: document.name,
  //   value: document.id,
  // }))

  // useEffect(() => {
  //   FormInstance.start({ where: { id: source.id } })
  // }, [])

  // return (
  //   <Flex vertical className="w-full">
  //     <FormInstance.FormView
  //       isModal={false}
  //       propsForm={{ buttonLabel: 'Submit' }}
  //     >
  //       <Form.Item
  //         label="Documents"
  //         name="configuration.docIds"
  //         rules={[
  //           {
  //             required: true,
  //             message: 'You must select at least one document',
  //           },
  //         ]}
  //       >
  //         <Select
  //           mode="multiple"
  //           placeholder="Select documents"
  //           options={optionsDocuments}
  //         />
  //       </Form.Item>
  //     </FormInstance.FormView>
  //   </Flex>
  // )
}
